import { memo, ReactElement, ReactNode, useState } from "react";
import classNames from "classnames";

import styles from "./style.module.scss";

export type AccordionProps = {
  header: ReactNode,
  headerClassName?: string,
  contentClassName?: string,
  className?: string
  icon?: ReactElement,
  children?: ReactNode | ReactNode[],
  defaultIsOpen?: boolean
}

export const Accordion = memo<AccordionProps>((
  {
    header,
    children,
    headerClassName,
    contentClassName,
    className,
    defaultIsOpen = false,
    icon,
  },
) => {
  const [ isOpen, setIsOpen ] = useState(defaultIsOpen);

  return (
    <div className={classNames(styles.root, className)}>
      <button
        type="button"
        className={classNames(styles.header, headerClassName)}
        onClick={() => setIsOpen(state => !state)}>
        {
          icon
            ? icon
            : (
              <div className={classNames(styles.icon, {
                [styles.active]: isOpen,
              })}>
                <span />
                <span />
              </div>
            )
        }
        {header}
      </button>
      <div className={classNames(styles.content, contentClassName)} aria-expanded={isOpen}>
        {children}
      </div>
    </div>
  );
});

